import { Action, defaultActions } from '#/common/components/DataGrid';
import { Asset } from '#/graphql/types';

export const actions: Action<Asset>[] = [...defaultActions];
